// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9de6753e","453":"245d58d1","732":"176e7303","977":"0d961588"}[chunkId] + ".chunk.js";
};